import BootstrapVue, {BvConfigOptions} from 'bootstrap-vue';
import Vue from 'vue';


const options: BvConfigOptions = {
  breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
};


Vue.use(BootstrapVue, options);
